$(function(){
  const pathname = location.pathname;
  const search = location.search;
  const domain = location.protocol + '//' + window.location.hostname + '/';
  console.log('pathname:'+pathname);
  console.log('search:'+search);
  /* チェック用URL */
  if (search.includes('developer')){
    $('body').addClass('develop');
    $('.shopify-policy__container').css({'max-width':'none'});
  }


  /* 検索フォームバグ対応（buttonのtypeをbuttonにしてもそもそも、✕ボタンで閉じなかった…） */
  $('.btn--close-search').on('click',function(){
    $('body').removeClass('predictive-overflow-hidden');
    $('.site-header__search-container').removeClass('is-active');
  });

  /* 検索結果ページの検索フォーム削除 */
  if (pathname.startsWith('/search')) {
    $('#search_group_close').on('click',function(){
      $('#search_group').remove();
    });
  }

  // 会員登録 20歳以上チェック
  if (pathname.includes('account/register')){
    $('#age').on('change', function() {
      if ($(this).prop('checked')) {
        $('#register-submit').prop('disabled', false);
      } else {
        $('#register-submit').prop('disabled', true);
      }
    });
  }


  // 熨斗一緒に
  document.addEventListener('click', function(e) {
    const isAddToCartBtn = e.target.closest('button.add-to-cart, button[name="add"], .add-to-cart');
    const isBuyNowBtn = e.target.closest('.shopify-payment-button__button, shopify-buy-it-now-button');

    if (!isAddToCartBtn && !isBuyNowBtn) return;

    const clickedBtn = isAddToCartBtn || isBuyNowBtn;
    const productForm = clickedBtn.closest('form');
    if (!productForm) return;

    const noshiSelect = productForm.querySelector('select[name="properties[熨斗]"]');
    if (!noshiSelect) return;

    const selectedOption = noshiSelect.options[noshiSelect.selectedIndex];
    const rawVariantId = selectedOption ? selectedOption.getAttribute('data-variantid') : null;
    const selectedValue = selectedOption ? selectedOption.value : '';

    if (!rawVariantId || rawVariantId.startsWith('9999') || selectedValue === "不要") {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    let mainVariantId = null;
    const variantSelect = productForm.querySelector('select[name="id"]');
    const variantInput = productForm.querySelector('input[name="id"]');
    if (variantSelect) {
      mainVariantId = variantSelect.value;
    } else if (variantInput) {
      mainVariantId = variantInput.value;
    }

    if (!mainVariantId) {
      alert('メイン商品のバリアントIDが取得できませんでした');
      return;
    }

    // DOMから安全にメイン商品タイトルを取得
    const productTitleEl = productForm.querySelector('.product__title, .product-title, h1');
    const mainProductTitle = productTitleEl ? productTitleEl.textContent.trim() : document.title;

    let itemQuantity = 1;
    let quantityInput = null;
    if (productForm.id) {
      quantityInput = document.querySelector(`input[name="quantity"][form="${productForm.id}"]`);
    }
    if (!quantityInput) {
      quantityInput = productForm.querySelector('[name="quantity"]');
    }
    if (quantityInput) {
      const parsedQty = parseInt(quantityInput.value, 10);
      if (!isNaN(parsedQty) && parsedQty > 0) {
        itemQuantity = parsedQty;
      }
    }

    clickedBtn.disabled = true;
    clickedBtn.classList.add('btn--loading');

    const payload = {
      items: [
        // 1. オプション商品を先に配置（先に処理させる）
        {
          id: Number(rawVariantId),
          quantity: itemQuantity,
          properties: {
            '対象商品': mainProductTitle,
            '熨斗種類': selectedValue
          }
        },
        // 2. メイン商品を後から配置（最後に処理され、カートの一番上に来る）
        {
          id: Number(mainVariantId),
          quantity: itemQuantity,
          properties: { '熨斗': selectedValue }
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(async response => {
      const data = await response.json();
      console.log('【APIレスポンス】', data);
      if (!response.ok) throw new Error(data.description || 'カート追加エラー');
      return data;
    })
    .then(() => {
      if (isBuyNowBtn) {
        window.location.href = '/checkout';
      } else {
        return fetch(`${window.location.pathname}?sections=cart-drawer`)
          .then(res => res.json())
          .then(sections => {
            if (sections['cart-drawer']) {
              const drawerElement = document.getElementById('CartDrawer') || document.querySelector('.cart-drawer');
              if (drawerElement) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
                const newDrawerContent = doc.getElementById('CartDrawer') || doc.querySelector('.cart-drawer');
                if (newDrawerContent) {
                  drawerElement.innerHTML = newDrawerContent.innerHTML;
                }
              }
            }

            if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
              window.theme.cart.getCart();
            }

            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          });
      }
    })
    .catch(err => {
      console.error('【エラー発生】', err);
      alert('エラーが発生しました: ' + err.message);
    })
    .finally(() => {
      clickedBtn.disabled = false;
      clickedBtn.classList.remove('btn--loading');
    });

  }, true);


  if( location.pathname === '/' ){

  /**** 
    トップページのFeatured productセクションの付与ポイントをajaxで取得する。
    ガイドページのtableから還元率を参照する。
  *****/
    let myrank;
    if($('.mrpoint-customer__rank-value').length){
      myrank = $('.mrpoint-customer__rank-value').text().trim().replace('会員','');
    }else{
      myrank = $('.mrpoint-customer__guest-message').text().trim().replace('会員','');
    }
    console.log('myrank:'+myrank)
    let foundRate = null;

    $.ajax({
      type: "GET",
      url: domain + 'pages/guide',
      dataType: 'html'
    }).done(function(data){
      let tableData = [];
      const $rankTable = $(data).find('.rank_table');
      $rankTable.find('tbody tr').each(function() {
        const row = [];
        const rank = $(this).find('td').eq(0).text().trim();
        const rate = $(this).find('td').eq(2).text().replace('%(税抜商品価格)','').trim();
        row.push(rank, rate);
        tableData.push(row);
      });
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i][0] === myrank) {
          foundRate = Number(tableData[i][1]);
          console.log('foundRate:' + foundRate);
          break; 
        }
      }
    
      let fp_price;
      $('.product-section').each(function(y) {
        fp_price = $(this).find('.product__price').text().replace(/,/g, '').replace('¥', '');
        console.log('付与ポイント:' + fp_price/100/1.1*foundRate);
        $(this).find('.pp').text('付与予定ポイント: '+Math.round(fp_price/100/1.1*foundRate)+' pt');
      });
    }).fail(function(){
      console.log(domain + 'pages/guide/ ajax通信失敗');
    });
  }

  // 熨斗一緒に
  document.addEventListener('click', function(e) {
    const isAddToCartBtn = e.target.closest('button.add-to-cart, button[name="add"], .add-to-cart');
    const isBuyNowBtn = e.target.closest('.shopify-payment-button__button, shopify-buy-it-now-button');

    if (!isAddToCartBtn && !isBuyNowBtn) return;

    const clickedBtn = isAddToCartBtn || isBuyNowBtn;
    const productForm = clickedBtn.closest('form');
    if (!productForm) return;

    const noshiSelect = productForm.querySelector('select[name="properties[熨斗]"]');
    if (!noshiSelect) return;

    const selectedOption = noshiSelect.options[noshiSelect.selectedIndex];
    const rawVariantId = selectedOption ? selectedOption.getAttribute('data-variantid') : null;
    const selectedValue = selectedOption ? selectedOption.value : '';

    if (!rawVariantId || rawVariantId.startsWith('9999') || selectedValue === "不要") {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    let mainVariantId = null;
    const variantSelect = productForm.querySelector('select[name="id"]');
    const variantInput = productForm.querySelector('input[name="id"]');
    if (variantSelect) {
      mainVariantId = variantSelect.value;
    } else if (variantInput) {
      mainVariantId = variantInput.value;
    }

    if (!mainVariantId) {
      alert('メイン商品のバリアントIDが取得できませんでした');
      return;
    }

    let itemQuantity = 1;
    let quantityInput = null;
    if (productForm.id) {
      quantityInput = document.querySelector(`input[name="quantity"][form="${productForm.id}"]`);
    }
    if (!quantityInput) {
      quantityInput = productForm.querySelector('[name="quantity"]');
    }
    if (quantityInput) {
      const parsedQty = parseInt(quantityInput.value, 10);
      if (!isNaN(parsedQty) && parsedQty > 0) {
        itemQuantity = parsedQty;
      }
    }


    const productTitleEl = productForm.querySelector('.product__title, .product-title, h1');
    const mainProductTitle = productTitleEl ? productTitleEl.textContent.trim() : document.title;

    clickedBtn.disabled = true;
    clickedBtn.classList.add('btn--loading');

    const payload = {
      items: [
        // 1. オプション商品
        {
          id: Number(rawVariantId),
          quantity: itemQuantity,
          properties: {
            '対象商品': mainProductTitle,
            '熨斗': selectedValue
          }
        },
        // 2. メイン商品
        {
          id: Number(mainVariantId),
          quantity: itemQuantity,
          properties: {
            '熨斗': selectedValue
          }
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(async response => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'カート追加エラー');
      return data;
    })
    .then(() => {
      if (isBuyNowBtn) {
        window.location.href = '/checkout';
      } else {
        return fetch(`${window.location.pathname}?sections=cart-drawer`)
          .then(res => res.json())
          .then(sections => {
            if (sections['cart-drawer']) {
              const drawerElement = document.getElementById('CartDrawer') || document.querySelector('.cart-drawer');
              if (drawerElement) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
                const newDrawerContent = doc.getElementById('CartDrawer') || doc.querySelector('.cart-drawer');
                if (newDrawerContent) {
                  drawerElement.innerHTML = newDrawerContent.innerHTML;
                }
              }
            }

            if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
              window.theme.cart.getCart();
            }

            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          });
      }
    })
    .catch(err => {
      console.error('【エラー発生】', err);
      alert('エラーが発生しました: ' + err.message);
    })
    .finally(() => {
      clickedBtn.disabled = false;
      clickedBtn.classList.remove('btn--loading');
    });

  }, true);

});



// オブジェクトJson整形
(() => {
  if (!document.querySelector('.pre-json')) return;
  class BuetifyPreJson {
    constructor(obj) {
      this.elms = document.querySelectorAll(`${obj.selector}`)
    }
    buetify() {
      [...this.elms].forEach(_elm => {
        const jsonText = _elm.textContent
        const jsonTextParse = JSON.parse(jsonText)
        _elm.textContent = JSON.stringify(jsonTextParse, null, 2)
      })
    }
    init() {
      this.buetify()
    }
  }
  const buetifyPreJson = new BuetifyPreJson({
    selector: '.pre-json',
  })
  buetifyPreJson.init()
})();
